import React from 'react';
import PropTypes from 'prop-types';
import RangeChart from '../RangeChart/RangeChart';
import styles from './AssetValueChart.css';

const AssetValueChart = ({
    valuePercent,
    barWidthPercent,
    labels,
    min,
    max
}) => {
    const level = ((valuePercent - min) / (max - min)) * 100;
    return (
        <div className="risk-potential">
            <RangeChart
                valuePercent={level}
                barWidthPercent={barWidthPercent}
                labels={labels}
            />
            <style jsx>{styles}</style>
        </div>
    );
};

AssetValueChart.defaultProps = {
    valuePercent: 0,
    barWidthPercent: 1,
    labels: ['0', '52 WEEK RANGE', '0'],
    min: 0,
    max: 0
};

AssetValueChart.propTypes = {
    /**
     * The value converted into a percentage
     */
    valuePercent: PropTypes.number,
    /**
     * Bar width percent
     */
    barWidthPercent: PropTypes.number,
    /**
     * labels
     */
    labels: PropTypes.arrayOf(PropTypes.string),
    /**
     * Min for chart
     */
    min: PropTypes.number,
    /**
     * Max for chart
     */
    max: PropTypes.number
};

export default AssetValueChart;
